import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=8d1b0a06&scoped=true"
import script from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=8d1b0a06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1b0a06",
  null
  
)

export default component.exports